import { useContext } from "react";
import {
  ErrorDialogContext,
  errorHandledSync,
} from "@/shared/context/error-context";
import { InstitutionsService } from "@/features/institutions/services/institutions-service";
import { useInstitutionsStates } from "@/features/institutions/hooks/use-institutions-states";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";


export const useInstitutions = () => {
  const {
    currentSearchCode,
    setCurrentSearchCode,
    showInstitutions,
    setShowInstitutions,
  } = useInstitutionsStates();

  const {
    institutions,
    setInstitutions,
  } = useInstitutionsContext();

  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  const institutionsService = new InstitutionsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 金融機関一覧取得
  const getInstitutions = async (institution_type: string) => {
    try {
      const res = await institutionsService.getInstitutions({
        institution_type: institution_type,
      });
      const institutions = res.map((item) => ({
        industryCode: item.industry_code,
        industryName: item.industry_name,
        companyCode: item.company_code,
        companyName: item.company_name,
        branchCode: item.branch_code,
        branchName: item.branch_name,
        searchCodeList: item.search_code_list,
        maintenanceype: item.maintenance_type,
      }));
      setInstitutions(institutions);
    } catch (error) {
      // エラーハンドリング
      console.log("getInstitutions", error);
      throw error;
    } finally {
      //
    }
  };

  // 表示金融機関頭文字絞り込み
  const filterInstitutionsBySearchCode = () => {
    if (!currentSearchCode) {
      setShowInstitutions(institutions);
      return;
    }

    const filtered = institutions.filter((item) => {
      const codes = item.searchCodeList.split(";").filter(Boolean);
      return codes.includes(currentSearchCode);
    });

    setShowInstitutions(filtered);
  };

  return {
    currentSearchCode,
    setCurrentSearchCode,
    showInstitutions,
    setShowInstitutions,
    getInstitutions: errorHandledSync(getInstitutions, setError),
    filterInstitutionsBySearchCode: errorHandledSync(filterInstitutionsBySearchCode, setError),
  };
};
